import { Component, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { IAppState } from "@edp-store/state/app.state";
import { Router } from "@angular/router";
import { getUser } from "@edp-store/selectors/user.selectors";
import { Menu } from "@edp-models/menu.model";
import { getMainMenu, getSelectOverlay } from "@edp-store/selectors/layout.selectors";
import { SelectOverlayAction } from "@edp-store/actions/layout.actions";
import { environment } from "@edp-environments/environment";

@Component({
    selector: "edp-e-menu-app",
    templateUrl: "./edp-e-menu-app.component.html",
    styleUrls: ["./edp-e-menu-app.component.scss"],
})
export class EdpEMenuAppComponent implements OnInit {
    public active: string;
    public isUserEdpE: boolean;

    public mainMenu: Menu[];
    public othersMenu: Menu[];
    public showOthers = false;
    private hasOverlayOpened = false;

    constructor(private store: Store<IAppState>, private router: Router) {
    }

    ngOnInit() {
        this.store.select(getUser).subscribe((user) => {
            if (user) {
                this.isUserEdpE = user.edpESubscribed;
            }
        });

        this.store.select(getSelectOverlay).subscribe(overlay => {
            if (!!overlay) {
                this.hasOverlayOpened = true;
            }
        });

        this.store.select(getMainMenu).subscribe(menu => {
            const menuVisible = menu.filter(i => !!i.visible);
            if (menuVisible.length > 5) {
                this.othersMenu = menuVisible.slice(4);
                this.mainMenu = [...menuVisible.slice(0, 4), this.getOtherMenu()];
            } else {
                this.mainMenu = menuVisible;
            }
        });
    }

    public setNewActiveMenuItem(selectedItem: Menu): void {
        if (environment.isApp && !!this.hasOverlayOpened) {
            sessionStorage.removeItem("mgm");
            this.store.dispatch(new SelectOverlayAction(null));
        }

        if (!this.isUserEdpE && selectedItem.name === "MENU.EDPE") {
            this.router.navigate(["/planeta-zero/inscricao"]);
        } else {
            if (selectedItem.callToAction) {
                selectedItem.callToAction();
            }
            if (selectedItem.routerPath) {
                if (this.showOthers) {
                    this.toggleOthers();
                }
                this.router.navigate(selectedItem.routerPath);
            }
        }
    }

    public toggleOthers(): void {
        this.showOthers = !this.showOthers;
    }

    private getOtherMenu(): Menu {
        return {
            visible: true,
            name: "MENU.OTHERS",
            icon: "icon-edponline-Bop-198 rotate-90",
            isActive: this.othersMenu ? this.othersMenu.some(menu => menu.isActive) : false,
            callToAction: () => {
                this.toggleOthers();
            }
        };
    }
}
